"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Snackbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _lab = require("@material-ui/lab");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Componente primário de interação com o usuário
 */
const Snackbar = _ref => {
  let {
    children,
    severity,
    show,
    handleClose,
    classes,
    autoHideDuration,
    noClose
  } = _ref;
  const defaultClasses = (0, _styles.useSnackStyles)();
  const customClasses = classes ? classes() : null;
  const snackbarStyle = customClasses ? customClasses.root : defaultClasses.root;
  const alertClasses = (0, _styles.useAlertStyles)();
  const [showAlert, setShowAlert] = (0, _react.useState)(show);
  (0, _react.useEffect)(() => {
    if (autoHideDuration) {
      const alertTimer = setTimeout(() => {
        setShowAlert(false);
      }, autoHideDuration);
      return () => clearTimeout(alertTimer);
    }
    return false;
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, noClose && showAlert && /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    classes: alertClasses,
    className: customClasses ? customClasses.root : '',
    severity: severity
  }, children), !noClose && /*#__PURE__*/_react.default.createElement(_core.Snackbar, {
    open: show,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    className: snackbarStyle,
    autoHideDuration: autoHideDuration,
    onClose: () => handleClose && handleClose()
  }, /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    onClose: () => handleClose && handleClose(),
    severity: severity,
    classes: alertClasses
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: defaultClasses.colorText
  }, children))));
};
exports.Snackbar = Snackbar;
Snackbar.propTypes = {
  /**
   * Texto do Snackbar
   */
  children: _propTypes.default.string.isRequired,
  /**
   * Define a cor e o ícone do alerta
   */
  severity: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']).isRequired,
  /**
   * Se 'true' o Snackbar é exibido
   */
  show: _propTypes.default.bool.isRequired,
  /**
   * Função para fechar o snackbar
   */
  handleClose: _propTypes.default.func,
  /**
   * Referência do hook makeStyles para gerar estilos
   */
  classes: _propTypes.default.func,
  /**
   * Quantidade de tempo, em milissegundos, que o snackbar ficará visível; funciona com noClose
   */
  autoHideDuration: _propTypes.default.number,
  /**
   * Se true, o snackBar nao possui o botao de fechar
   */
  noClose: _propTypes.default.bool
};
var _default = exports.default = Snackbar;
Snackbar.defaultProps = {
  handleClose: null,
  classes: null,
  autoHideDuration: null,
  noClose: false
};